module.exports = __webpack_public_path__ + "assets/img/37_1618_big.11cb99b9.jpg";